import { defaultLanguage, Locale, useIntl } from '@weenat/wintl'
import React from 'react'

const APP_STORE_BADGE_LOCALES: Record<Locale, string> = {
  en: 'en-us',
  fr: 'fr-fr',
  de: 'de-de',
  it: 'it-it',
  es: 'es-es',
  pl: 'pl-pl',
  pt: 'pt-pt',
  nl: 'nl-nl'
}

const STORE_BUTTON_WIDTH = 246
const STORE_BUTTON_HEIGHT = 82

const StoreBadge: React.FC = () => {
  const { t, locales } = useIntl()
  const locale = locales.current
  return (
    <Flex $flexDirection='column' $gap='md' $justifyContent='center' $alignItems='center'>
      <a href={`${t('weenat.links.stores.google')}`} style={{ display: 'inline-block' }}>
        <img
          src={`https://play.google.com/intl/en_us/badges/static/images/badges/${locale || defaultLanguage}_badge_web_generic.png`}
          alt='Download on the play Store'
          style={{
            /* there is margin included in android image so we have to cheat here to keep both img the same size*/
            width: STORE_BUTTON_WIDTH + 14,
            height: STORE_BUTTON_HEIGHT + 20,
            verticalAlign: 'middle',
            objectFit: 'contain'
          }}
        />
      </a>
      <a href={t('weenat.links.stores.apple')} style={{ display: 'inline-block' }}>
        <img
          src={`https://toolbox.marketingtools.apple.com/api/v2/badges/download-on-the-app-store/black/${APP_STORE_BADGE_LOCALES[locale || defaultLanguage]}?releaseDate=1591920000`}
          alt='Download on the App Store'
          style={{
            width: STORE_BUTTON_WIDTH,
            height: STORE_BUTTON_HEIGHT,
            verticalAlign: 'middle',
            objectFit: 'contain'
          }}
        />
      </a>
    </Flex>
  )
}

export default StoreBadge
